import { render, staticRenderFns } from "./licenseStatusDetail.vue?vue&type=template&id=37709476"
import script from "./licenseStatusDetail.vue?vue&type=script&lang=js"
export * from "./licenseStatusDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37709476')) {
      api.createRecord('37709476', component.options)
    } else {
      api.reload('37709476', component.options)
    }
    module.hot.accept("./licenseStatusDetail.vue?vue&type=template&id=37709476", function () {
      api.rerender('37709476', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/lim/licenseStatusDetail.vue"
export default component.exports